<template>
    <div class="exception-body notfound">
        <img src="assets/layout/images/logo-mides-white.svg" alt="mides-layout" class="logo" />

        <div class="exception-content">
            <div class="exception-title">NO ENCONTRADO</div>
            <div class="exception-detail">El recurso solicitado no está disponible.</div>
            <router-link to="/beneficios">Ir a Beneficios</router-link>
        </div>
    </div>
</template>

<script>
export default {};
</script>